import React from 'react';
import Icon from '../AppIcon';

const SessionProgressIndicator = ({ currentStep = 0, steps = [] }) => {
  const defaultSteps = [
    { id: 'qr-scan', label: 'Escanear', icon: 'QrCode', path: '/qr-code-scanner' },
    { id: 'bill-review', label: 'Revisar', icon: 'Receipt', path: '/bill-overview' },
    { id: 'item-select', label: 'Seleccionar', icon: 'ShoppingCart', path: '/item-selection' },
    { id: 'payment', label: 'Pagar', icon: 'CreditCard', path: '/payment-summary' },
  ];

  const progressSteps = steps?.length > 0 ? steps : defaultSteps;

  const getStepStatus = (index) => {
    if (index < currentStep) return 'completed';
    if (index === currentStep) return 'current';
    return 'pending';
  };

  const getStepClasses = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-success text-success-foreground border-success';
      case 'current':
        return 'bg-primary text-primary-foreground border-primary animate-pulse-soft';
      case 'pending':
        return 'bg-muted text-muted-foreground border-border';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  const getConnectorClasses = (index) => {
    const isCompleted = index < currentStep;
    return `flex-1 h-0.5 ${isCompleted ? 'bg-success' : 'bg-border'}`;
  };

  return (
    <div className="w-full bg-surface border-b border-border px-4 py-3">
      <div className="max-w-4xl mx-auto">
        {/* Desktop Progress Indicator */}
        <div className="hidden sm:flex items-center justify-between">
          {progressSteps?.map((step, index) => (
            <React.Fragment key={step?.id}>
              <div className="flex flex-col items-center space-y-2">
                <div
                  className={`
                    flex items-center justify-center w-10 h-10 rounded-full border-2 transition-all duration-300
                    ${getStepClasses(getStepStatus(index))}
                  `}
                >
                  {getStepStatus(index) === 'completed' ? (
                    <Icon name="Check" size={16} />
                  ) : (
                    <Icon name={step?.icon} size={16} />
                  )}
                </div>
                <span className="text-xs font-medium text-text-secondary">
                  {step?.label}
                </span>
              </div>
              
              {index < progressSteps?.length - 1 && (
                <div className={getConnectorClasses(index)} />
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Mobile Progress Indicator */}
        <div className="sm:hidden">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-foreground">
              Paso {currentStep + 1} de {progressSteps?.length}
            </span>
            <span className="text-xs text-text-secondary">
              {progressSteps?.[currentStep]?.label}
            </span>
          </div>
          
          <div className="flex space-x-1">
            {progressSteps?.map((_, index) => (
              <div
                key={index}
                className={`
                  h-2 flex-1 rounded-full transition-all duration-300
                  ${index <= currentStep ? 'bg-primary' : 'bg-muted'}
                `}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionProgressIndicator;